import React from 'react';
import SettingBlock from './SettingBlock';
import RoSColorPicker from './RoSColorPicker';
import FontPicker, { type SAFonts } from '@atoms/FontPicker';
import { useSelectedSlide } from '@components/Presentation/hooks/useSelectedSlide';

interface SlideHeadingProps {
  color: string;
  updateColor: (color: string | boolean) => void;
  hasBorderTop?: boolean;
}
export default function SlideHeading({ color, updateColor, hasBorderTop = true }: SlideHeadingProps) {
  const selectedSlide = useSelectedSlide();

  return (
    <SettingBlock
      title="Heading"
      addPadding
      defaultExpanded={true}
      hasBorderTop={hasBorderTop}
    >
      <RoSColorPicker
        color={color || '#FFFFFF'}
        onChange={updateColor}
        disableGradient
      >
        Heading color
      </RoSColorPicker>
      <div className='flex justify-between items-center'>
        <span className='text-sm'>Heading font</span>
        <FontPicker
          selectedFont={selectedSlide.setting.HeadingFont as SAFonts || 'Sans-Serif'}
          onSelectFont={(font: SAFonts) => selectedSlide.handler.updateSetting('HeadingFont', font)}
        />
      </div>
    </SettingBlock>
  );
}
